export default __webpack_public_path__ + "static/media/decrease.8a4ec03e.svg";